import React from "react";

const Tyc = () => {
  return (
    <div className="container mt-5">
      <h1 className="mb-4">Términos y Condiciones de Uso de Ilustradoz</h1>
      <p className="text-muted">Última actualización: 10 de mayo de 2025</p>

      <div className="mb-4">
        <p>
          Al acceder a la aplicación (app) de Ilustradoz, usted confirma que está de acuerdo y sujeto a los términos de servicio contenidos en estos Términos y Condiciones. Estos términos se aplican a todo el sitio web, la aplicación y a cualquier comunicación electrónica entre usted e Ilustradoz.
        </p>
      </div>

      <section className="mb-4">
        <h3>1. Aceptación de los Términos</h3>
        <p>
          Al utilizar la aplicación Ilustradoz, usted acepta estos Términos y Condiciones en su totalidad. Si no está de acuerdo con alguno de estos términos, no utilice la aplicación.
        </p>
      </section>

      <section className="mb-4">
        <h3>2. Descripción del Servicio</h3>
        <p>
          Ilustradoz es una aplicación móvil dedicada a estudiantes escolares y preuniversitarios del Perú, que permite practicar exámenes de admisión de universidades peruanas.
        </p>
      </section>

      <section className="mb-4">
        <h3>3. Cuentas de Usuario</h3>
        <p>
          3.1. Los usuarios pueden utilizar la aplicación de forma anónima o crear una cuenta.
        </p>
        <p>
          3.2. Si un usuario elige crear una cuenta, se le pedirá que proporcione cierta información personal. Esta información se utilizará para personalizar la experiencia del usuario y realizar un seguimiento de su progreso.
        </p>
      </section>

      <section className="mb-4">
        <h3>4. Recopilación de Datos</h3>
        <p>
          4.1. Ilustradoz recopila los puntajes de los usuarios en los exámenes de práctica.
        </p>
        <p>
          4.2. Estos datos se utilizan para analizar el rendimiento de los usuarios, identificar áreas de mejora y optimizar el contenido de la aplicación.
        </p>
        <p>
          4.3. Ilustradoz se compromete a proteger la privacidad de los usuarios y a utilizar sus datos de acuerdo con la legislación peruana aplicable.
        </p>
      </section>

      <section className="mb-4">
        <h3>5. Uso de la Aplicación</h3>
        <p>
          5.1. Los usuarios se comprometen a utilizar la aplicación de manera responsable y legal.
        </p>
        <p>
          5.2. Está prohibido utilizar la aplicación para fines ilegales, difamatorios o que infrinjan los derechos de terceros.
        </p>
      </section>

      <section className="mb-4">
        <h3>6. Propiedad Intelectual</h3>
        <p>
          6.1. Todos los derechos de propiedad intelectual relacionados con la aplicación y su contenido (incluyendo, pero no limitado a, textos, gráficos, logotipos, imágenes y software) son propiedad de Ilustradoz o de sus licenciantes.
        </p>
        <p>
          6.2. Los usuarios se comprometen a no copiar, modificar, distribuir, vender o arrendar ninguna parte de la aplicación o su contenido sin el consentimiento previo por escrito de Ilustradoz.
        </p>
      </section>

      <section className="mb-4">
        <h3>7. Terminación</h3>
        <p>
          7.1. Ilustradoz se reserva el derecho de terminar el acceso de un usuario a la aplicación en caso de que infrinja alguna norma establecida en estos Términos y Condiciones.
        </p>
        <p>
          7.2. Al terminar el acceso de un usuario a la aplicación, su información será eliminada.
        </p>
      </section>

      <section className="mb-4">
        <h3>8. Limitación de Responsabilidad</h3>
        <p>
          En la máxima medida permitida por la ley peruana, Ilustradoz no será responsable por ningún daño directo, indirecto, incidental, especial, consecuencial o punitivo que surja del uso o la imposibilidad de usar la aplicación.
        </p>
      </section>

      <section className="mb-4">
        <h3>9. Ley Aplicable y Jurisdicción</h3>
        <p>
          Estos Términos y Condiciones se regirán e interpretarán de acuerdo con las leyes de la República del Perú. Cualquier disputa relacionada con estos términos se resolverá en los tribunales competentes de la ciudad de Lima.
        </p>
      </section>

      <section className="mb-4">
        <h3>10. Cambios en los Términos y Condiciones</h3>
        <p>
          Ilustradoz se reserva el derecho de modificar estos Términos y Condiciones en cualquier momento. Los cambios se notificarán a los usuarios dentro de la aplicación, a través de notificaciones. Los nuevos Términos y Condiciones entrarán en vigor desde su publicación en mayo de 2025.
        </p>
      </section>

      <section className="mb-4">
        <h3>11. Información de Contacto</h3>
        <p>
          Si tiene alguna pregunta o inquietud sobre estos Términos y Condiciones, puede contactarnos a través de{" "}
          <a href="mailto:ilustradozapp@gmail.com">ilustradozapp@gmail.com</a>
        </p>
      </section>
    </div>
  );
};

export default Tyc;